import React from 'react'

const t = {
  FR: {
    Submit: 'Soumettre',
    Cancel: 'Annuler',
    Yes: 'Oui',
    No: 'Non',
    'Are you sure?': <>Êtes-vous certain&nbsp;?</>,
    
    Add: 'Ajouter',
    Close: 'Fermer',
    Continue: 'Continuer',
    Finish: 'Terminer',
    Select: 'Selectionner',
    Begin: 'Commencer',
    StartOver: `Recommencer`,
  },
  EN: {
    Submit: 'Submit',
    Cancel: 'Cancel',
    Yes: 'Yes',
    No: 'No',
    'Are you sure?': 'Are you sure?',
    
    Add: 'Add',
    Close: 'Close',
    Continue: 'Continue',
    Finish: 'Finish',
    Select: 'Select',
    Begin: 'Start',
    StartOver: `Start over`,
  },
  ES: {
    Submit: 'Entregar',
    Cancel: 'Cancelar',
    Yes: 'Sí',
    No: 'No',
    'Are you sure?': 'Estas seguro',
    
    Add: 'Agregar',
    Close: 'Cerca',
    Continue: 'Continuar',
    Finish: 'Finalizar',
    Select: 'Seleccionar',
    Begin: 'Empezar',
    StartOver: `Empezar de nuevo`,
  },
  PT: {
    Submit: 'Entrar',
    Cancel: 'Cancelar',
    Yes: 'Sim',
    No: 'Não',
    'Are you sure?': 'Tem certeza?',
    
    Add: 'Adicionar',
    Close: 'Fechar',
    Continue: 'Continuar',
    Finish: 'Terminar',
    Select: 'Selecione',
    Begin: 'Começar',
    StartOver: `Começar de novo`,
  },
}

export default t